import { connect } from 'react-redux';
import { selectPay2meURL } from 'src/store/payment/selectors';
import { finishPayment } from 'src/store/payment/slice';
import { selectCurrentPopup } from 'src/store/popup/selectors';
import { resetPopupState } from 'src/store/popup/slice';
import { getIsMobile } from 'src/store/view/selectors';
import Pay2MePopup from './Pay2MePopup';

const mapStateToProps = (state) => ({
  isPopupOpened: selectCurrentPopup(state) === 'pay2me',
  url: selectPay2meURL(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  onClose: resetPopupState,
  onSuccess: finishPayment,
};

export default connect(mapStateToProps, mapDispatchToProps)(Pay2MePopup);
